export enum EInventoryPendingState {
  Created = 'Created',
  NeedSellerApprove = 'NeedSellerApprove',
  NeedBuyerApprove = 'NeedBuyerApprove',
  Success = 'Success',
  Canceled = 'Canceled',
  Timeout = 'Timeout',
}
